import api from "./api"

export const getBlock = async (
    blockId: string, 
    params: any, 
): Promise<{
    block: any,
    loading: boolean,
    isError: boolean
}> => {

    const {data, status} = await api.get(blockId, {
        params: params
    })

    return {
        block: data,
        loading: !data && !(status >= 300),
        isError: status >= 300
    }
}